import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Grid, Button, Card, CardContent, Switch } from '@mui/material';
import { Page, Header } from 'components';
import OutliersDialogForm from './components/OutliersDialogForm';
import OutliersV2DialogForm from './components/OutliersV2DialogForm';

import {
	SetFormState, GetClustersNames, GetSiteListDates
} from '../actions/Shutdown3gActions';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(1),
	},
	tabs: {
		marginTop: theme.spacing(1),
	},
	content: {
		marginTop: theme.spacing(1),
	},
}));

const Shutdown3g = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.shutdown3gReducer.formState);
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);

	useEffect(() => {
		dispatch(GetClustersNames(userId));
	}, []);

	return (
		<Page className={classes.root} title="3GSD">
			<Header module="Modules" view="3GSD" />
			<Grid className={classes.container} container spacing={1}>
				<Grid item lg={12} xs={12}>
					<OutliersDialogForm />
				</Grid>
			</Grid>
			<Grid className={classes.container} container spacing={1}>
				<Grid item lg={12} xs={12}>
					<OutliersV2DialogForm />
				</Grid>
			</Grid>
		</Page>
	);
};

export default Shutdown3g;
